import { TableCard } from '../../../../components'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { NotificacoesListHeader } from './components/header/NotificacoesListHeader'
import { NotificacoesTable } from './table/NotificacoesTable'
import { useAbrirNotificacaoPelaUrl } from './hooks/useAbrirNotificacaoPelaUrl'

const NotificacoesList = () => {
  useAbrirNotificacaoPelaUrl()

  return (
    <TableCard>
      <NotificacoesListHeader />
      <NotificacoesTable />
    </TableCard>
  )
}

export const NotificacoesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <NotificacoesList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
